import { FloatingForm } from "../../../../../components/common/Converter";
import CardView from "../../../../../components/common/CardView";
import { InputFactory } from "nq-component";
import BaseListPage from "../../../../../base/BaseListPage";
import WorkFlowHierarchy from "./WorkFlowHierarchy";

export default class AddTask extends BaseListPage {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      description: "",
      // request: "",
      // approve: "",
      // reject: "",
      // retrieve: "",
      isAssignToRequestor: false,
      selectAllEmployee: false,
      index: "",
      hierarchy: {},
    };
  }

  async componentDidMount() {
    const { taskObj } = this.props;
    console.log("TASSSKKKKKK:: ", taskObj);
    if (taskObj) {
      this.setState({ ...taskObj });
    }
  }

  async handleAssignTaskChange(field, value) {
    this.setState({ [field]: value });
  }

  onToggleChange(field) {
    const otherField =
      field === "isAssignToRequestor"
        ? "selectAllEmployee"
        : "isAssignToRequestor";

    // Reset hierarchy (same as your logic)
    if (field === "isAssignToRequestor" || field === "selectAllEmployee") {
      this.setState((prev) => ({
        hierarchy: {
          ...prev.hierarchy,
          region: "",
          office: "",
          division: "",
          section: "",
          unit: "",
          cluster: "",
          selecteduser: "",
        },
      }));
    }

    // Final toggle state update
    this.setState((prevState) => ({
      // Flip the one we clicked
      [field]: !prevState[field],

      // Force the other one to be false when this one is true
      [otherField]: prevState[field] ? prevState[otherField] : false,
    }));
  }

  FormInput(label, type, required) {
    const displayLabel = {
      Name: "Name",
      Description: "Description",
    };

    return (
      <>
        <label className="mb-2" style={{ fontSize: "14px" }}>
          {displayLabel[label]} <span className="text-danger">*</span>
        </label>
        <InputFactory
          type={type}
          required={required}
          value={this.state[label.toLowerCase()]}
          placeholder={
            label === "Description" ? "Write here the task description..." : ""
          }
          onChange={(value) =>
            this.handleAssignTaskChange(label.toLowerCase(), value)
          }
        />
      </>
    );
  }

  handleAddTask() {
    this.props.addTaskData(this.state);
    this.props.isTaskOpen();
  }

  handleObjectChange(hierarchy) {
    // if (hierarchy?.assignedPersonnel !== "") {
    //   hierarchy.multiplePersonnel = [{ id: hierarchy?.assignedPersonnel?.id }];
    // }
    // console.log("HEIGHT: ", hierarchy);
    this.setState({ hierarchy });
  }

  render() {
    return (
      <FloatingForm width="40rem">
        <CardView style={{ padding: 0 }}>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              this.handleAddTask();
            }}
          >
            <h4 className="fs-5 fw-bold pt-3 ps-3">Task Details</h4>
            <hr />
            <div className="w-100" style={{ padding: "0 1rem" }}>
              <div className="w-100">
                {["Name", "Description"].map((label, index) => (
                  <div className="p-3" key={index}>
                    {this.FormInput(
                      label,
                      label === "Description" ? "Text" : "String",
                      true
                    )}
                  </div>
                ))}
                <hr />
                <div className="d-flex justify-content-between align-items-center ps-4 pe-4 pb-2 bt-2">
                  <label>Select all employee</label>
                  <button
                    className="btn btn-primary"
                    type="button"
                    onClick={() => this.onToggleChange("selectAllEmployee")}
                  >
                    <i
                      className={
                        this.state.selectAllEmployee
                          ? "bi bi-toggle-on"
                          : "bi bi-toggle-off"
                      }
                    />
                  </button>
                </div>
                <div className="d-flex justify-content-between align-items-center ps-4 pe-4 pb-2 bt-2">
                  <label>Assign to Requestor's Supervisor</label>
                  <button
                    className="btn btn-primary"
                    type="button"
                    onClick={() => this.onToggleChange("isAssignToRequestor")}
                  >
                    <i
                      className={
                        this.state.isAssignToRequestor
                          ? "bi bi-toggle-on"
                          : "bi bi-toggle-off"
                      }
                    />
                  </button>
                </div>
                <div className="pe-3 ps-3 mb-2">
                  <WorkFlowHierarchy
                    object={this.state.hierarchy}
                    className="pb-2 d-grid"
                    handleObjectChange={this.handleObjectChange.bind(this)}
                    assginToRequestor={this.state.isAssignToRequestor}
                    selectAllEmployee={this.state.selectAllEmployee}
                  />
                </div>
                <hr />
              </div>
            </div>
            <hr />
            <div className="w-100 d-flex justify-content-end gap-4 mb-3 pe-3">
              <button
                className="btn btn-light fs-sm"
                type="button"
                onClick={this.props.isTaskOpen}
              >
                Cancel
              </button>
              <button className="btn btn-primary" type="submit">
                Ok
              </button>
            </div>
          </form>
        </CardView>
      </FloatingForm>
    );
  }
}
